import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, map, of, ReplaySubject } from 'rxjs';
import { ILoggedInUser } from '../models/user';
import { ILoginForm } from '../models/forms/login-form.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { IProfileUpdateForm } from '../models/forms/profile-update-form.model';
import { IRegistrationFormValue } from '../models/forms/registration-form.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private apiUrl = '/api/auth/';

  private loggedInUserSource = new ReplaySubject<any>(1);

  loggedInUser = toSignal<ILoggedInUser>(this.loggedInUserSource);

  registerUser(registerForm: IRegistrationFormValue) {
    return this.http.post<{ token: string, userDetails: ILoggedInUser }>(this.apiUrl + 'register', registerForm).pipe(map(resp => {
       localStorage.setItem('token', resp.token);
      localStorage.setItem('loggedInUser', JSON.stringify(resp.userDetails))
      this.setLoggedInUser(resp.userDetails);
      return;
    }));
  }

  login(loginFormValue: ILoginForm) {
    return this.http.post<{ token: string, userDetails: ILoggedInUser }>(this.apiUrl + 'login', loginFormValue).pipe(map(resp => {
      localStorage.setItem('token', resp.token);
      localStorage.setItem('loggedInUser', JSON.stringify(resp.userDetails))
      this.setLoggedInUser(resp.userDetails);
    }))
  }

  logoutUser() {
    this.setLoggedInUser();
    localStorage.removeItem('token')
    localStorage.removeItem('loggedInUser')
  }

  updateProfile(updateForm: IProfileUpdateForm) {
    return this.http.put<ILoggedInUser>(this.apiUrl + 'update-profile', updateForm).pipe(map((resp) => {
      this.setLoggedInUser(resp)
    }))
  }

   setLoggedInUser(user?: ILoggedInUser) {
    if (user)
      this.loggedInUserSource.next(user)
    else
      this.loggedInUserSource.next(null)
  }

}
